module.exports = __webpack_public_path__ + "static/media/lpr_third_party.4bb86ddb.svg";